var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.terms)?_c('BackgroundLayout',{scopedSlots:_vm._u([{key:"mainHeaderTitle",fn:function(){return [_vm._v(" "+_vm._s(_vm.terms.title)+" ")]},proxy:true}],null,false,22080823)},[_c('div',{class:``,domProps:{"innerHTML":_vm._s(_vm.terms.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }